import { CurrencyInput } from '@/components/ui/currency-input';
import { centsToInitialValue } from '@/lib/currency';
import { cn } from '@/lib/utils';
import type { Payment } from '@/models/types';
import { observer } from 'mobx-react-lite';

const DealPaymentsOwed = observer(
  ({
    payments,
    className,
    startAdornmentClassName,
  }: {
    payments: Payment[];
    className?: string;
    startAdornmentClassName?: string;
  }) => {
    return (
      <CurrencyInput
        value={centsToInitialValue(
          payments.reduce((acc, payment) => {
            if (payment.deleted_at) {
              return acc;
            }

            if (!payment.confirmed_date) {
              return acc + payment.amount;
            }

            return acc;
          }, 0),
        )}
        readOnly={true}
        placeholder={''}
        className={cn(
          'text-uneditable  !text-[13px] text-right w-16',
          className,
        )}
        startAdornmentClassName={startAdornmentClassName}
      />
    );
  },
);

export default DealPaymentsOwed;
